import React from "react";

const Contact = () => {
  return (
    <section id="h4-pricing" className="relative w-full overflow-hidden">
      <div className="w-full h4-pricing-wrapper pb-[6rem] md:pb-[8rem] max-md:pt-[120px] md:pt-[160px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="title-area w-full flex justify-center">
              <div className="flex flex-col items-center">
                <div className="py-0.5 px-5 bg-[#1D109E07] border-[#1D109E1e] border rounded-[30px] font-medium text-[#1D109E] mb-5">
                  <span>Have Questions?</span>
                </div>
                <div className="">
                  <h2 className="text-main-black font-semibold text-24 sm:text-48 text-center max-w-[519px]">
                    Contact Information
                  </h2>
                  <p className="mt-2 text-gray-600 text-center">
                    Feel free to connect with our customer representative, if
                    you face any problems
                  </p>
                </div>
              </div>
            </div>
            <section className="py-16 md:py-[50px]">
              <div className="theme-container w-full mx-auto grid grid-cols-7 lg:grid-cols-12 gap-y-16 lg:gap-y-0 lg:gap-x-[70px] max-md:px-0">
                {/* address start  */}
                <div className="col-span-5 max-md:col-span-12">
                  <div className="contact-style-one-info">
                    <ul>
                      <li>
                        <div className="icon">
                          <i className="fas fa-phone-alt" aria-hidden="true" />
                        </div>
                        <div className="content">
                          <h5 className="title">Hotline</h5>
                          <a href="tel:919211407720" className="text-[16px]">
                            tel:+91-9211226940
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i
                            className="fas fa-map-marker-alt"
                            aria-hidden="true"
                          />
                        </div>
                        <div className="info">
                          <h5 className="title">Our Location</h5>
                          <p>
                            UGF- 71- Upper Ground Ansal Plaza - 2 Chiranjiv Vihar Ghaziabad ( U P )- 201002
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i
                            className="fas fa-envelope-open-text"
                            aria-hidden="true"
                          />
                        </div>
                        <div className="info">
                          <h5 className="title">Official Email</h5>
                          <a
                            href="mailto:support@truvanaopd.com"
                            className="text-[16px]"
                          >
                            support@truvanaopd.com
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* address end  */}
                {/* contact form start */}
                <div className="col-span-7 max-md:col-span-12">
                <img src="assets/images/contact1.png" alt="" />
                </div>
                {/* contact-form end  */}
              </div>
            </section>
          </div>
        </div>
        <div className="shape-1 absolute left-40 top-96 z-10">
          <img src="assets/images/home-four/shape-1.webp" alt="" />
        </div>
        <div className="shape-2 absolute right-96 top-96 z-10">
          <img src="assets/images/home-four/shape-2.webp" alt="" />
        </div>
        <div className="shape-3 absolute left-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-3.webp" alt="" />
        </div>
        <div className="shape-4 absolute right-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-4.webp" alt="" />
        </div>
      </div>
    </section>
  );
};

export default Contact;
